import React, { Fragment, useEffect, useState, lazy, Suspense } from "react";
import { ApplicantsSc } from "./Appliants.sc";
import { Modal } from "react-bootstrap";
import ApplicantDetails from "./ApplicantComp/ApplicantComp";
import { get_all_applicant_list } from "../../api/Applicants/get_applicantlist";
import { get_ind_applicant_list } from "../../api/Applicants/get_individual_applicant";
import { date } from "zod";

interface Applicant {
  first_name: string;
  last_name: string;
  phonbe_number: string;
  title: string;
  email: string;
  looking_for: number;
  experience: number;
  degree: string;
  status: string;
  created_at: string;
}

const Applicants = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [currentApplicant, setCurrentApplicant] = useState(null);
  const [applicants, setApplicants] = useState<Applicant[]>([]);
  const [filterArray, setFilterArray] = useState<Applicant[]>([]);
  const [searchInput, setSearchInput] = useState("");
  const [statusFiled, setStatusField] = useState("");
  const [aApplicant, setAApplicant] = useState<any>([]);
  const [refresh, setRefresh] = useState<boolean>(false)
  const [selectedRow, setSelectedRow] = useState<number>(0)
  const openDetailsModal = (applicantId: any) => {
    applicantId && setCurrentApplicant(applicantId);
    setShowDetails(true);
  };
  const closeDetailsModal = () => {
    setCurrentApplicant(null);
    setShowDetails(false);
    // getApplicants();
  };

  const handleClick = (applicant_id: any) => {
    openDetailsModal(applicant_id);
  };

  const fetchApplicantList = async () => {
    try {
      const res: Applicant[] = await get_all_applicant_list();
      console.log("_DATA-APPLICANTS", res);

      const uniqueApplicants = Array.from(
        new Map(
          res.map((applicant) => {

            const createdDate = new Date(applicant.created_at);

            if (isNaN(createdDate.getTime())) {
              return [
                `${applicant.first_name.toLowerCase()}|${applicant.last_name.toLowerCase()}|${applicant.phonbe_number}|${applicant.looking_for}|N/A`, 
                applicant,
              ];
            }

            const processedDate = createdDate.toISOString().split('T')[0];
            const displayTime = createdDate.toISOString().split('T')[1].substring(0, 8); 

            return [
              `${applicant.first_name.toLowerCase()}|${applicant.last_name.toLowerCase()}|${applicant.phonbe_number}|${applicant.looking_for}|${processedDate}`,
              {
                ...applicant,
                processedDate, 
                displayTime,   
              },
            ];
          })
        ).values());

      setApplicants(uniqueApplicants);
      setFilterArray(uniqueApplicants);
      setRefresh(false);
    } catch (err) {
      console.error(`Error fetching applicants: ${err}`);
    }
  };

  useEffect(() => {
    fetchApplicantList();
    setAApplicant(filterArray[selectedRow])

  }, [refresh]);

  const openModal = (applicant: any, idx: number) => {
    console.log(idx, "modal open data--");
    setSelectedRow(idx)
    setShowDetails(true);
    setAApplicant(applicant);
  };



  const handleSearchInputChange = (event: any) => {
    setSearchInput(event.target.value);
  };

  // const arr = filterArray.filter((applicant: any) => {
  //   const isNameMatch = applicant?.first_name
  //     ?.toLowerCase()
  //     .includes(searchInput?.toLowerCase());

  //   // Use logical OR to combine the conditions
  //   return isNameMatch;
  // });

  const arr = filterArray.filter((applicant: any) => {
    const isNameMatch = applicant?.first_name
      ?.toLowerCase()
      .includes(searchInput.toLowerCase());
    const isLookingForMatch = applicant?.title
      ?.toLowerCase()
      .includes(searchInput.toLowerCase());

    // Combine both filters
    return isNameMatch || isLookingForMatch;
  });


  const [fileds, setFileds] = useState([
    {
      name: "degree",
      status: false,
    },
    {
      name: "status",
      status: false,
    },
  ]);
  function changeFileds(fil: any) {
    const arr = fileds.map((data) => {
      return fil === data.name
        ? {
          ...data,
          status: !data.status,
        }
        : data;
    });
    setFileds(arr);
  }

  const sortApplicantsByDate = () => {
    const sortedApplicants = [...applicants].sort((a, b) => {

      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateA.getTime() - dateB.getTime();
    });
    setApplicants(sortedApplicants);
  };
  // useEffect(() => {
  //   sortApplicantsByDate();
  // }, []);
  const handleSortByDate = () => {
    sortApplicantsByDate();
  };
  console.log(fileds);
  return (
    <ApplicantsSc>
      {applicants && applicants?.length > 0 ? (
        <div className="mt-3 mx-3 applicant-body">
          <div className="heading"> List of Applicants </div>
          <input
            onChange={handleSearchInputChange}
            placeholder="Search for applicants"
            value={searchInput}
            style={{ border: "1px solid black" }}
          />


          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone number</th>
                <th>Email</th>
                <th>Application Date</th>
                {fileds?.[0]?.status ? (
                  <th style={{ display: "flex", gap: "1rem" }}>
                    <select>
                      <option>Bacheolrs</option>
                      <option>Masters</option>
                    </select>
                    <div onClick={() => changeFileds("degree")}>X</div>
                  </th>
                ) : (
                  <th onClick={() => changeFileds("degree")}>Degree</th>
                )}
                <th>Exper</th>
                {fileds?.[1]?.status ? (
                  <th style={{ display: "flex", gap: "1rem" }}>
                    <select>
                      <option>Selected</option>
                      <option>Rejected</option>
                      <option>Interviewed</option>
                    </select>
                    <div onClick={() => changeFileds("status")}>X</div>
                  </th>
                ) : (
                  <th onClick={() => changeFileds("status")}>Status</th>
                )}
              </tr>
            </thead>
            <tbody>
              {arr?.length > 0 ? (
                arr?.map((data: any, idx: any) => (
                  <tr
                    key={idx}
                    style={{ color: "#000" }}
                    onClick={() => openModal(data, idx)}
                  >
                    <td>{idx + 1}</td>
                    <td>{data?.first_name}</td>
                    <td>{data?.phonbe_number}</td>
                    <td>{data?.email}</td>
                    <td
                    //  onClick={()=>handleSortByDate()}
                    >
                      <div> {data?.processedDate}</div>  
                      <div style={{ color: 'gray' }}>{data?.displayTime}</div>  
                    </td>
                    <td>{data?.degree}</td>
                    <td>{data?.experience}</td>
                    <td>{data?.status}</td>
                  </tr>
                ))
              ) : (
                <div style={{ color: "black" }}>No data</div>
              )}
            </tbody>
          </table>

          <Modal
            show={showDetails}
            fullscreen
            onHide={closeDetailsModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Applicant</Modal.Title>
            </Modal.Header>

            <div>
              <ApplicantDetails

                applicant={aApplicant}
                close={closeDetailsModal}
                fetchApplicant={fetchApplicantList}
                setRefresh={setRefresh}
              />
            </div>
          </Modal>
        </div>
      ) : (
        <div>Applicant data is fetching please wait...</div>
      )}
    </ApplicantsSc>
  );
};

export default Applicants;
